import axios from '../../utils/axios.js'

export const findByRegionId = (query) => axios.setAxiosGetPromise('features/findByRegionId', query)

export const batchSave = (body) => axios.setAxiosPostPromise('features/batchSave', body)

export const batchEdit = (body) => axios.setAxiosPostPromise('features/batchEdit', body)

export const featurePublish = (query) => axios.setAxiosGetPromise('features/featurePublish', query)

export const featureRestore = (query) => axios.setAxiosGetPromise('features/featureRestore', query)

export const getRefreshViewChangeMath = (query) => axios.setAxiosGetPromise('features/getRefreshViewChangeMath', query)

export const getPublishInfo = (query) => axios.setAxiosGetPromise('features/getPublishInfo', query)

export const getPublishFeaturesByRegion = (query) => axios.setAxiosGetPromise('features/getPublishFeaturesByRegion', query)

export const getPublishFeaturesByRegions = (query) => axios.setAxiosGetPromise('features/getPublishFeaturesByRegions', query)

export const getPublishFeatureById = (query) => axios.setAxiosGetPromise('features/getPublishFeatureById', query)




// WEBPACK FOOTER //
// ./src/services/system/features.js